import { ItemCardType } from "../../../../../Shared/components/ItemCard/utils/itemcard-types";
import { product_default_image } from "../../../../../Shared/utils/constants";
import { RecipeIngredientReplacementMode, RecipeSelectionType } from "../../../../OrderFlowProvider/OrderFlowTypes";
export const buildProductCardProps = ({ product, baseImageUrl, isSubscription, isEditFlow, HandleProductIncrement, HandleProductDecrement, HandleRenewSwitch, isCustomizeModalOpen, setIsCustomizeModalOpen, formatPrice, }) => {
    const itemPriceObject = formatPrice({ displayPriceOverride: product.productPrice });
    const images = product.productImages.length > 0 ? product.productImages : [product_default_image];
    return {
        itemImageUrls: images,
        itemName: product.productName,
        itemDescription: product.productDescription,
        imageBaseUrl: baseImageUrl,
        itemPriceObject,
        itemSalePrice: product.hasSale ? String(product.salePriceDisplay) : undefined,
        quantity: product.quantity,
        isAddDisabled: false,
        isMinusDisabled: false,
        isCustomizeDisabled: false,
        handleQuantityIncrement: () => HandleProductIncrement(product.productId, product.DayOfWeek),
        handleQuantityDecrement: () => HandleProductDecrement(product.productId, product.DayOfWeek),
        handleRenewSwitch: isSubscription && !isEditFlow && HandleRenewSwitch
            ? () => HandleRenewSwitch(product.productId, product.DayOfWeek)
            : undefined,
        isRenewing: product.isRenewing,
        itemChips: [],
        recipeFlags: [],
        recipeSelectionType: RecipeSelectionType.Both,
        itemType: ItemCardType.Product,
        recipeIngredientReplacementMode: RecipeIngredientReplacementMode.DISABLED,
        assignmentCount: 0,
        isCustomizeModalOpen,
        setIsCustomizeModalOpen,
    };
};
